import { Component } from 'react'

const isChunkError = (error) =>
  /Loading chunk|dynamically imported module|Failed to fetch dynamically/i.test(
    error?.message || ''
  )

/**
 * Catches lazy-route failures.
 *
 * The common case is a user with an open tab after a new deploy: the old chunk
 * filenames are gone, the dynamic import 404s, and the app would otherwise white-screen.
 * A reload fixes exactly that, so offer it rather than showing a generic error.
 */
class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Route error:', error, info)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    const stale = isChunkError(error)

    return (
      <div className="tool-container" style={{ paddingTop: 48, textAlign: 'center' }}>
        <h1>{stale ? 'This page was updated' : 'Something went wrong'}</h1>
        <p style={{ color: 'var(--text-secondary)', maxWidth: 520, margin: '12px auto 24px' }}>
          {stale
            ? 'A new version of the site was deployed while this tab was open. Reload to get it.'
            : 'This tool failed to load. Reloading usually fixes it.'}
        </p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          Reload page
        </button>
      </div>
    )
  }
}

export default RouteErrorBoundary
